<script setup>
import { ref, watch } from 'vue'

const emits = defineEmits(['update:visible', 'update:reschedule'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true,
  },
})

const isVisible = ref(props.show)

watch(() => props.show, newVal => {
  isVisible.value = newVal
})

const closeModal = () => {
  isVisible.value = false
  emits('update:visible', false)
}
const reschedule = () => {
  closeModal()
  emits('update:reschedule')
}
</script>

<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-container">
      <button class="modal-close" @click="closeModal()">×</button>
      <div class="modal-content">
        <p class="modal-text" v-html="$t('reschedule.coolbox-modal.message')">
        </p>
        <div class="modal-actions">
          <button class="btn btn-primary" @click="reschedule()">{{ $t('reschedule.coolbox-modal.rescheduleButton') }}</button>
          <button class="btn btn-secondary" @click="closeModal()">{{ $t('reschedule.coolbox-modal.cancelButton') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
}

.modal-container {
  background-color: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: scaleIn 0.2s ease-out;
}

.modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  font-size: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
  transition: color 0.2s;

  &:hover {
    color: #f44336;
  }
}

.modal-content {
  margin-top: 1rem;
}

// Animations
@keyframes fadeIn {
  from {
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    background-color: rgba(0, 0, 0, 0.3);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-text {
  font-size: 1rem;
  color: #333;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  text-align: center;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;

  .btn {
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s ease;

    &-primary {
      background-color: #21979E;
      color: white;

      &:hover {
        background-color: #116367;
      }
    }

    &-secondary {
      background-color: #e0e0e0;
      color: #333;

      &:hover {
        background-color: #cfcfcf;
      }
    }
  }
}
</style>
